import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
import PromoteInstallmentsModal from "./PromoteInstallmentsModal.js";
/* empty css                              */
const PromoteInstallmentsLabel = ({
  installmentPrice,
  numberOfInstallments,
  textAlign,
  modalBodySlot
}) => {
  const { getFormattedLabel } = useIntl();
  const label = React.useMemo(() => {
    return getFormattedLabel("common.promoteInstallments.label", {
      labelData: {
        installmentPrice,
        numberOfInstallments
      }
    });
  }, [getFormattedLabel, installmentPrice, numberOfInstallments]);
  if (!label) return null;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("promote-installments-label", {
        [`promote-installments-label--text-align-${textAlign}`]: textAlign
      })
    },
    /* @__PURE__ */ React.createElement("span", { "data-t": "promoteInstallmentsLabel" }, label),
    modalBodySlot && /* @__PURE__ */ React.createElement("div", { className: "promote-installments-label__tooltip-slot" }, /* @__PURE__ */ React.createElement(PromoteInstallmentsModal, { modalBodySlot }))
  );
};
export {
  PromoteInstallmentsLabel as default
};
//# sourceMappingURL=PromoteInstallmentsLabel.js.map
